import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=24ce6214&scoped=true&"
import script from "./PlanList.vue?vue&type=script&lang=js&"
export * from "./PlanList.vue?vue&type=script&lang=js&"
import style0 from "./PlanList.vue?vue&type=style&index=0&id=24ce6214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ce6214",
  null
  
)

export default component.exports